// extracted by mini-css-extract-plugin
export default {"wrapperOuter":"styles_wrapperOuter__j-Ra6","wrapper":"styles_wrapper__Mss3V","close":"styles_close__kmdfB"};